const e = "shimmer_16-3-1", n = {
  "cdr-skeleton-bone": "cdr-skeleton-bone_16-3-1",
  "cdr-skeleton-bone__shimmer": "cdr-skeleton-bone__shimmer_16-3-1",
  shimmer: e,
  "cdr-skeleton-bone--line": "cdr-skeleton-bone--line_16-3-1",
  "cdr-skeleton-bone--heading": "cdr-skeleton-bone--heading_16-3-1",
  "cdr-skeleton-bone--rectangle": "cdr-skeleton-bone--rectangle_16-3-1",
  "cdr-skeleton-bone--square": "cdr-skeleton-bone--square_16-3-1"
};
export {
  n as default,
  e as shimmer
};
